import { render, staticRenderFns } from "./TitolareEffettivo.vue?vue&type=template&id=6a7b4e7c&scoped=true&"
import script from "./TitolareEffettivo.vue?vue&type=script&lang=js&"
export * from "./TitolareEffettivo.vue?vue&type=script&lang=js&"
import style0 from "./TitolareEffettivo.vue?vue&type=style&index=0&id=6a7b4e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b4e7c",
  null
  
)

export default component.exports